import { render, staticRenderFns } from "./tsNew.vue?vue&type=template&id=2eaa12d9&scoped=true&"
import script from "./tsNew.vue?vue&type=script&lang=js&"
export * from "./tsNew.vue?vue&type=script&lang=js&"
import style0 from "./tsNew.vue?vue&type=style&index=0&id=2eaa12d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa12d9",
  null
  
)

export default component.exports